export default class SelectedAppointment {
    constructor(parent, router) {
        this.router = router;
        this.el = parent.el.querySelector('.batd-schedule-info');
        this.scheduleDateElement = this.el.querySelector('.schedule-date');
        this.scheduleTimeElement = this.el.querySelector('.schedule-duration');
        this.retailerPhone = parent.el.querySelector('.batd-dealer-telephone');
        this.retailerDirection = parent.el.querySelector('.batd-get-directions');
        this.retailerChangeLink = parent.el.querySelector('.dealer-name-container a');
        this.bind();
    }

    bind() {
        this.router.addDataListener(() => this.populate());
        this.retailerChangeLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.router.update('search');
        });
    }

    populate() {
        const routerData = this.router?.data;
        if (this.retailerPhone) {
            this.retailerPhone.href = `tel:${routerData?.selectedDealer?.telephone}`;
            this.retailerPhone.innerText = routerData?.selectedDealer?.telephone;
        }
        if (this.retailerDirection) {
            this.retailerDirection.href = `https://www.google.com/maps/dir//${routerData?.selectedDealer?.name},${routerData?.selectedDealer?.address.formatted}/@${routerData?.selectedDealer?.address.lat},${routerData?.selectedDealer?.address.lng}`;
        }
        this.scheduleDateElement.innerHTML = routerData.selectedDate ? routerData.selectedDate : '';
        this.scheduleTimeElement.innerHTML = routerData.selectedTime ? routerData.selectedTime : '';
    }
}
